module.exports = __webpack_public_path__ + "static/media/clipboard-check.522c7e4a.svg";